import React, { useState, useEffect } from "react";

const TextCapture = ({ question, onChange }) => {
  const [value, setValue] = useState(""); // Initialize with empty string

  const handleChange = (event) => {
    const newValue = event.target.value;
    setValue(newValue);
  };

  useEffect(() => {
    if (onChange) {
      onChange(value); // Notify parent of value changes
    }
  }, [value, onChange]); // Dependencies to ensure effect runs on value change

  return (
    <div className="flex flex-col w-full">
      {/* Question Section */}
      <h4 className="text-sm uppercase text-gray-500">Question</h4>
      <h4 className="text-xl font-bold mt-3 mb-6">
        {question?.title ?? "Untitled Question"}
      </h4>

      {/* Answer Section */}
      <div className="answer-wrapper">
        <h4 className="text-sm uppercase text-indigo-600 mb-4">
          Enter Your Answer
        </h4>
        <textarea
          value={value}
          onChange={handleChange}
          placeholder="Answer"
          className="w-full p-4 border border-gray-300 rounded-xl resize-y focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-gray-800 placeholder-gray-400"
          rows={4}
        />
      </div>
    </div>
  );
};

export default TextCapture;
